{
  "manager": {
    "uploadWaiverModal": {
      "title": "Upload Waiver",
      "selectFile": "Select a File",
      "fileRequiredFeedback": "This field is required and must be 10MB or less.",
      "nameOfWaiver": "Name of Waiver",
      "nameRequiredFeedback": "This field is required.",
      "namePlaceholder": "Name of the waiver"
    },
    "waiverListContainer": {
      "title": "Waivers",
      "uploadWaiver": "Upload Waiver",
      "waiverUploaded": "Waiver uploaded",
      "copiedToClipboard": "Copied to clipboard"
    },
    "waiverAgreementIndex": {
      "backToWaivers": "Back to Waivers",
      "title": "Waiver Agreements",
      "assignWaiver": "Assign Waiver",
      "fieldRequired": "This field is required.",
      "agreementSaved": "Agreement saved",
      "saveError": "Failed to save agreement",
      "pageTitle": "View Waiver Agreements"
    }
  }
}
